"use client";

import { motion } from "motion/react";
import type { ReactNode } from "react";
import { cn } from "../../lib";

/**
 * Default full loop duration for `animate-shake` (`--shake-interval-duration` in theme).
 * Override duration via `--shake-interval-duration` on an ancestor.
 */
export const SHAKE_INTERVAL_CYCLE_S = 2.5;

/** Active shake window within each loop (middle 20% of `shake-interval`: 40–60%). */
export const SHAKE_INTERVAL_BURST_S = 0.5;

interface ShakeEffectMotionProps {
	children: ReactNode;
	className?: string;
}

/**
 * Gentle scale pulse + repeating rotation shake (`animate-shake`). Same duration; shake burst is
 * keyed at 40–60% of the CSS cycle to hit max scale (~50% with default Motion easing).
 */
export function ShakeEffectMotion({
	children,
	className,
}: ShakeEffectMotionProps) {
	return (
		<motion.div
			animate={{ scale: [1, 1.06, 1] }}
			transition={{
				duration: SHAKE_INTERVAL_CYCLE_S,
				repeat: Number.POSITIVE_INFINITY,
				ease: "easeInOut",
			}}
			className={cn("origin-center", className)}
		>
			<div className="animate-shake origin-center">{children}</div>
		</motion.div>
	);
}
